import React, { FunctionComponent, useContext, useEffect, useState } from "react";
import AppContext from '../../App.context';
import { getCompanyLogo } from "../../helpers/PackageJsonHelper";
import { getResource } from "../../helpers/ResourcesHelper";
// import logo from '../../images/logo_generic.png';
//import logo from '../../images/Logo_Premier.png';
import { createBeneficiaryUser, getNewBeneficiaryUserKey } from "../../api/NetworkingBeneficiaries";
import { OnlineRightsNames } from "../../helpers/OnlineRightsHelper";
import Button from "../inputs/Button";

const logo = getCompanyLogo();

interface BeneficiaryUserProps {
  beneficiaryuserkey: any;
  onFinishBeneficiaryUser: Function;
}

export const BeneficiaryUser: FunctionComponent<BeneficiaryUserProps> = (props) => {
  const { showModal, showLoadingModal, hideLoadingModal } = useContext(AppContext);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const applicationName = 'ForeignExchange';
  const [beneficiaryPersonID, setBeneficiaryPersonID] = useState('');
  const [beneficiaryEmail, setBeneficiaryEmail] = useState('');
  const [beneficiaryName, setBeneficiaryName] = useState('');
  const [customerID, setCustomerID] = useState(0);
  const [contactPersonID, setContactPersonID] = useState('');

  useEffect(() => {
    if (props.beneficiaryuserkey && props.beneficiaryuserkey !== '') {
      getNewBeneficiaryUserKey(props.beneficiaryuserkey).then(
        (jsonResponse) => {
          if (jsonResponse.httpStatusCode === 200) {
            if (jsonResponse.CustomerId > 0) {
              setBeneficiaryName(jsonResponse.BeneficiaryName);
              setBeneficiaryEmail(jsonResponse.BeneficiaryEmail);
              setBeneficiaryPersonID(jsonResponse.BeneficiaryPersonID);
              setCustomerID(jsonResponse.CustomerId);
              setContactPersonID(jsonResponse.PersonID);
              localStorage.setItem('SessionID', jsonResponse.SessionID);
            }
            else {
              showModal(getResource('Js_MessageError_TitleError'), getResource('Message_Beneficiary_UserURLExpired'));
              setTimeout(() => { props.onFinishBeneficiaryUser(); }, 2000);
            }
          }
          else {
            showModal(getResource('Js_MessageError_TitleError'), getResource('InvalidRequest'));
            setTimeout(() => { props.onFinishBeneficiaryUser(); }, 2000);
          }
        }
      );
    }
    else {
      showModal(getResource('Js_MessageError_TitleError'), getResource('InvalidRequest'));
      setTimeout(() => { props.onFinishBeneficiaryUser(); }, 2000);
    }

  }
    , [props.beneficiaryuserkey]);

  const onSavePasswordClick = () => {
    var values = validateNewPassword();

    if (values.isValid) {
      showLoadingModal();

      var role = [];
      role.push(OnlineRightsNames.OL_BeneficiaryUser);
      var objUser = {
        User: {
          'ApplicationName': applicationName,
          'UserID': beneficiaryPersonID,
          'UserName': beneficiaryEmail,
          'Email': beneficiaryEmail,
          'noDaysPasswordExpires': 0,
          'noPreviousPwds': 0,
          'IsLock': false,
          'CommissionOverride': 0,
          'dealLimit': 0,
          'UpdatedBy': beneficiaryPersonID,
          'ReportsToUserID': contactPersonID
        },
        Claim: {
          'Questions': {},
          'Password': newPassword,
          'NewPassword': confirmPassword,
          'SecurityToken': 'ae83565b-9ffb-4075-9477-4da20dab2fae'
        },
        Roles: role,
        CustomerID: customerID
      }

      createBeneficiaryUser(objUser).then(
        (jsonResponse) => {
          if (jsonResponse.httpStatusCode === 200) {

            showModal(getResource('Js_MessageError_TitleSuccess'), getResource('Message_Thanks_For_Registering'));
            hideLoadingModal();

            setTimeout(() => { props.onFinishBeneficiaryUser(); }, 2000);
          } else {
            var msg = getResource('SomethingWentWrongTryAgain') + ' ' + jsonResponse.httpStatusCode
            if (jsonResponse.Message !== undefined) {
              msg = jsonResponse.Message
            } else {
              if (jsonResponse.ErrorMessage !== undefined) {
                msg = jsonResponse.ErrorMessage
              }
            }
            hideLoadingModal();
            showModal(getResource('Js_MessageError_TitleError'), msg);
          }
        }
      );
    }
    else {
      var msg = ''
      let className = 'modal-message-xs';
      switch (values.errorNumber) {
        default:
        case 0:
          {
            msg = getResource('SomethingWentWrongTryAgain');
            break;
          }
        case 1:
          {
            msg = getResource('Password_Validation');
            className = 'modal-message';
            break;
          }
        case 2:
          {
            msg = getResource('DataMsgNewConfirmPasswordNoMatch');
            break;
          }
      }
      showModal(getResource('Js_MessageError_TitleError'), msg, className);
    }
  }

  const validateNewPassword = () => {
    var valid = true
    var errorId = 0
    var regStrength = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&])[0-9a-zA-Z@#$%&]{6,50}$/;

    if (newPassword === undefined || newPassword === '' ||
      newPassword === null || !regStrength.test(newPassword)) {
      valid = false
      errorId = 1
    }

    if (confirmPassword === undefined || confirmPassword === '' ||
      confirmPassword === null) {
      valid = false
      errorId = 1
    }

    if (valid === true) {
      if (newPassword !== confirmPassword) {
        valid = false
        errorId = 2
      }
    }

    return {
      isValid: valid,
      errorNumber: errorId,
    }
  }

  return (
    <React.Fragment>
      <div className="col prime-container login-container">
        <div className="row prime-container">
          <div className="col-md-4 col-xs-12"></div>
          <div className="row col-md-4 col-xs-12 middle-xs">
            <div className="row col-xs-12 center-xs">
              <div className="col-xs-8  col-lg-10">
                <div className="row">
                  <img className="col-xs-12 login-image" src={logo} alt="" />
                </div>
                <div className="row">
                  <div className="row">
                    <div className="row">
                      <span className="question-fp">{getResource('BeneficiaryEmail')}</span>
                    </div>
                    <div className="row">
                      <input type="text" value={beneficiaryEmail}
                      ></input>
                    </div>
                  </div>
                  <div className="row">
                    <div className="row">
                      <span className="question-fp">{getResource('Label_NewPassword')}</span>
                    </div>
                    <div className="row">
                      <input type="password" value={newPassword}
                        onChange={(event) => {
                          setNewPassword(event.target.value);
                        }} ></input>
                    </div>
                  </div>
                  <div className="row">
                    <div className="row">
                      <span className="question-fp">{getResource('Label_ConfirmPassword')}</span>
                    </div>
                    <div className="row">
                      <input type="password" value={confirmPassword}
                        onChange={(event) => {
                          setConfirmPassword(event.target.value);
                        }} ></input>
                    </div>
                  </div>
                  <div className="row" style={{ marginBottom: '20px' }}>
                    <span className="question-fp">{getResource('Password_Validation')}</span>
                  </div>
                  <div className="row center-xs">
                    <Button id="login-button" type="active" onClick={onSavePasswordClick}>
                      {getResource('Button.Save')}
                    </Button>
                  </div>
                </div>


              </div></div></div></div>
      </div>
    </React.Fragment>
  );
}

export default BeneficiaryUser;

